export const enum InviteEmailConflict {
  ALREADY_MEMBER = 'alreadyMember',
  ALREADY_INVITED = 'alreadyInvited',
}
